/* eslint-disable no-underscore-dangle */
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { Typography, TextField, makeStyles } from "@material-ui/core";
import { Auth } from "aws-amplify";
import useFormFields from "lib/forms";
import LoginComponent from "./LoginComponent";

const successAlertMessage = "A recovery code was sent to your email.";

const useStyles = makeStyles(() => ({
  root: {
    padding: "0px"
  },
  divider: {
    marginTop: "30px",
    marginBottom: "10px"
  },
  formButton: {
    marginTop: "20px"
  },
  formTitle: {
    marginBottom: "15px"
  },
  recoveryMesage: {
    fontSize: "12px"
  },
  alertBox: {
    boxShadow:
      "rgba(9, 30, 66, 0.28) 0px 4px 8px -2px, rgba(9, 30, 66, 0.3) 0px 0px 1px;",
    fontSize: "12px",
    lineHeight: "20px",
    marginBottom: "16px",
    transform: "rotateX(0deg)",
    transformOrigin: "50% 0px",
    transitionProperty:
      "visibility, height, margin-bottom, opacity, transform, padding",
    transitionDuration: "0s, 0.2s, 0.2s, 0.2s, 0.2s",
    transitionTimingFunction: "ease-in-out",
    borderRadius: "3px",
    padding: "16px"
  },
  sendCodeTextField: {
    marginTop: "5px"
  }
}));

export default function ForgotPasswordComponent() {
  const classes = useStyles();
  const history = useHistory();
  const [codeRequested, setCodeRequested] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [fields, handleFieldChange] = useFormFields({
    email: "",
    code: "",
    password: "",
    confirmPassword: ""
  });

  const handleSendCodeSubmit = () => {
    Auth.forgotPassword(fields.email)
      .then(() => {
        setCodeRequested(true);
        setAlertMessage(successAlertMessage);
      })
      .catch(err => {
        setAlertMessage(err.message);
      });
  };

  const resetPasswordSubmit = event => {
    event.preventDefault();

    if (fields.confirmPassword !== fields.password) {
      setAlertMessage("Passwords provided do not match.");
      return false;
    }

    if (fields.password.length < 6) {
      setAlertMessage("Password must contain at least 6 characters.");
      return false;
    }

    Auth.forgotPasswordSubmit(fields.email, fields.code, fields.password)
      .then(() => {
        return history.push({
          pathname: "/login",
          state: { passwordReset: true }
        });
      })
      .catch(err => {
        setAlertMessage(err.message);
      });

    return false;
  };

  return (
    <LoginComponent dividerLinkTo="/login" dividerLinkText="Back to Sign In">
      <Typography
        align="center"
        component="h1"
        variant="h6"
        classes={{ h6: classes.formTitle }}
      >
        Forgot password?
      </Typography>
      {alertMessage && <div className={classes.alertBox}>{alertMessage}</div>}
      {codeRequested ? (
        <>
          <form onSubmit={resetPasswordSubmit}>
            <TextField
              variant="outlined"
              size="small"
              margin="normal"
              required
              fullWidth
              name="code"
              label="Code"
              type="code"
              id="code"
              autoComplete="off"
              onChange={handleFieldChange}
            />
            <TextField
              variant="outlined"
              size="small"
              margin="normal"
              required
              fullWidth
              name="password"
              label="New password"
              type="password"
              id="password"
              autoComplete="off"
              onChange={handleFieldChange}
            />
            <TextField
              variant="outlined"
              size="small"
              margin="normal"
              required
              fullWidth
              name="confirmPassword"
              label="Confirm password"
              type="password"
              id="confirmPassword"
              autoComplete="off"
              onChange={handleFieldChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.formButton}
            >
              Change Password
            </Button>
            <Button
              type="button"
              fullWidth
              variant="outlined"
              color="primary"
              className={classes.formButton}
              onClick={() => handleSendCodeSubmit()}
            >
              Resend code
            </Button>
          </form>
        </>
      ) : (
        <>
          <Typography
            variant="body1"
            classes={{ body1: classes.recoveryMesage }}
          >
            We will send a recovery email to
          </Typography>
          <form
            noValidate
            method="post"
            onSubmit={event => {
              event.preventDefault();
              handleSendCodeSubmit(event);
            }}
          >
            <TextField
              variant="outlined"
              size="small"
              margin="normal"
              classes={{ root: classes.sendCodeTextField }}
              required
              fullWidth
              label="Email"
              name="email"
              type="email"
              id="email"
              autoComplete="off"
              onChange={handleFieldChange}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.formButton}
            >
              Send Code
            </Button>
          </form>
        </>
      )}
    </LoginComponent>
  );
}
